/*
 * @Description:
 * @Date: 2020-09-26 17:30:44
 * @LastEditors: jml
 */
const game = {
  state: {
    info: {},
    rewards: [],
  },
  mutations: {
    SET_INFO(state, info) {
      state.info = info;
    },
    SET_REWARDS(state, rewards) {
      state.rewards = rewards;
    },
  },
  actions: {
    setInfo({ commit, state }, info) {
      commit("SET_INFO", info);
    },
    setRewards({ commit, state }, rewards) {
      commit("SET_REWARDS", rewards);
    },
  },
};
export default game;
